/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { MdOutlineCopyAll } from 'react-icons/md';
import { IconBase } from 'react-icons';
import Button from '~/components/button';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import Loading from '~/components/loading';
import Container from '~/components/container';

import ListConference from '../components/listConference';
import HeaderConference from '../components/headerConference';

import useApi, { ApiMethod } from '~/hooks/useApi';
import Endpoints from '~/services/endpoints';

import * as St from './styles';
import { IAntecipationPurchase } from '../model';
import { currencyMask } from '~/utils/masks';
import { icons } from '~/assets';
import ConferencePaymentOptions from '../components/paymentOptions';
import Popover from '~/components/Popover';

interface IGeneratePixResponse {
  base64?: string;
  emv?: string;
  txid?: string;
}

const AntecipationMethodPayment: React.FC = () => {
  const history = useHistory<any>();
  const locationState = history.location.state;

  const {dataPurchase} = locationState.locationState;
  console.log('Info - ', locationState, dataPurchase)

  const [valorTotal, setValorTotal] = useState('');
  const [dialog, setDialog] = useState({
    open: false,
    error: false,
    pix: false,
  });
  const [dialogMessage, setDialogMessage] = useState('');
  const [data, setData] = useState<IAntecipationPurchase[]>(null);
  const [codePix, setCodePix] = useState<IGeneratePixResponse>([] as IGeneratePixResponse);
  const [descontoTotal, setDescontoTotal] = useState('');

  const RequestCreateAntecipationCaixa = useApi(
    Endpoints.invoices.postAntecipationArray,
    ApiMethod.POST,
  );

  const RequestCreateAntecipationPix = useApi(
    Endpoints.invoices.postAntecipationArray,
    ApiMethod.POST,
  );

  const RequestChargePixGenerate = useApi<IGeneratePixResponse>(
    Endpoints.invoices.postChargePixGenerate,
    ApiMethod.POST,
  );

  useEffect(() => {
    const value = [] as IAntecipationPurchase[];
    dataPurchase?.map((dataP: IAntecipationPurchase) => {
      if (dataP.parcelasAAntecipar > 0) {
        value.push(dataP);
      }
      return dataP;
    });
    setData(value);
  }, []);

   useEffect(() => {
     async function populaValor() {
       let aux = 0;
       let auxDesconto = 0;
       if (data) {
         setValorTotal('');
         setDescontoTotal('');
         data.map((item) => {
           aux = item.valorAntecipacao + aux;
         });
         data.map((item) => {
           auxDesconto = item.valorDesconto + auxDesconto;
         })
         setValorTotal(String(aux));
         setDescontoTotal(String(auxDesconto));
       }
     }
 
     populaValor();
   }, [data]);

  const requestFinancialParcelCaixa = async (payload) => {
    try {
      const response: any = await RequestCreateAntecipationCaixa.callApi(
        payload,
      );

      if (response.status >= 200 && response.status < 300) {
        setDialog({ open: true, error: false, pix: false });
        setDialogMessage('Solicitação enviada com sucesso!');
      } else {
        setDialog({ open: true, error: true, pix: false });
        setDialogMessage(
          response.data?.mensagem || 'Tivemos um erro, Tente novamente!',
        );
      }
    } catch (err) {
      setDialog({ open: true, error: true, pix: false });
      setDialogMessage('Tivemos um erro, Tente novamente!');
    }
  };
  const requestFinancialParcelPix = async (payload) => {
    try {
      const response: any = await RequestCreateAntecipationPix.callApi(payload);

      if (response.status >= 200 && response.status < 300) {
        setDialog({ open: true, error: false, pix: true });
        setDialogMessage('Solicitação enviada com sucesso!');
      } else {
        setDialog({ open: true, error: true, pix: true });
        setDialogMessage(
          response.data?.mensagem || 'Tivemos um erro, Tente novamente!',
        );
      }
    } catch (err) {
      setDialog({ open: true, error: true, pix: true });
      setDialogMessage('Tivemos um erro, Tente novamente!');
    }
  };

  const handleSubmit = async (paymentOption: 'PIX' | 'CAIXA') => {

    if (paymentOption === "PIX") {
      const payload = data.length > 0 ? {
        cpf: data[0]?.cpf,
        valor: Number(valorTotal),
      } : null;

      try {
        const response = await RequestChargePixGenerate.callApi(payload);

        if (response.status >= 200 && response.status < 300) {
          setCodePix(response.data);

          const {emv, base64, txid} = response.data

          const payloadAntecipation = [];

          data.map((dataP: IAntecipationPurchase) => {
            payloadAntecipation.push({
              cartao: dataP?.cartao,
              cpf: dataP?.cpf,
              dataFechamento: String(moment(dataP?.dataCorte).format('YYYY-MM-DD')),
              email: dataP?.email,
              idParcelamento: dataP.idCompra,
              id_fatura: dataP.idFatura,
              nomeCliente: dataP?.nomeCompleto,
              parcelasAntecipadas: dataP?.parcelasAAntecipar,
              valorAntecipacao: dataP?.valorAntecipacao,
              tipoAntecipacao: 'COMPRA',
              qrcodeBase64: base64,
              txId: txid,
              pixCopiaECola: emv,
              origemAntecipacao: 'CENTRAL',
            });
          });
       
         await requestFinancialParcelPix(payloadAntecipation);
        } 
        
        if (response.status >= 400) {
          setDialog({open: true, error: true, pix: false})
          setDialogMessage(response.mensagem ? response.mensagem : 'Serviço indisponível')
        }
      } catch (error) {
        console.log(error);
    }
  } else if (paymentOption === 'CAIXA') {
    const payload = []

      data.map((dataP: IAntecipationPurchase) => {
        payload.push({
          cartao: dataP?.cartao,
          cpf: dataP?.cpf,
          dataFechamento: String(moment(dataP?.dataCorte).format('YYYY-MM-DD')),
          email: dataP?.email,
          idParcelamento: dataP.idCompra,
          id_fatura: dataP.idFatura,
          nomeCliente: dataP?.nomeCompleto,
          parcelasAntecipadas: dataP?.parcelasAAntecipar,
          valorAntecipacao: dataP?.valorAntecipacao,
          tipoAntecipacao: 'COMPRA',
          origemAntecipacao: 'CENTRAL',
        });
      })

      await requestFinancialParcelCaixa(payload)
  }
  };

  const [popoverPixIsOpen, setPopoverPixIsOpen] = useState(false);

  return (
    <Container>
        <Loading
        status={
          RequestCreateAntecipationPix.loading ||
          RequestCreateAntecipationCaixa.loading || 
          RequestChargePixGenerate.loading
        }
      />



      <Dialog
        icon={dialog?.error ? icons.exclamation : icons.check}
        open={dialog?.open}
        title={
          dialog?.error
            ? 'Houve um erro, tente novamente'
            : 'Solicitação concluida com sucesso!'
        }
        positiveLabel="Entendi"
        widthInPercent={30}
        positiveAction={() => {
          if (!dialog.error) {
            history.push('/invoice/antecipation/purchase');
          }
          setDialog({ open: false, error: false, pix: false });
        }}
        message={dialogMessage}
      >
        {dialog?.pix ? (
          <ContainerFlex gap="14">
            <ContainerFlex row center gap="8">
              <St.Title style={{ fontWeight: 700, fontSize: '24px' }}>
                Pix copia e cola:
              </St.Title>
              <IconBase
                size={24}
                fontSize={24}
                style={{ cursor: 'pointer' }}
                onClick={async () => {
                  await navigator.clipboard.writeText(codePix?.emv);
                  setPopoverPixIsOpen(true);
                  setTimeout(() => setPopoverPixIsOpen(false), 3000);
                }}
              >
                <MdOutlineCopyAll />
              </IconBase>
            </ContainerFlex>

            <St.Info>
              {codePix.emv}
            </St.Info>
          </ContainerFlex>
        ) : null}
      </Dialog>
      <div
        style={{
          position: 'absolute',
          zIndex: 999,
          right: '17px',
          top: '2rem',
        }}
      >
        <Popover open={popoverPixIsOpen}>
          <ContainerFlex row center gap="8">
            <img width={16} height={16} src={icons.check} alt="check" />
            <p>Código copiado com sucesso!</p>
          </ContainerFlex>
        </Popover>
      </div>
      {data?.length > 0 ? (
        <>
          <HeaderConference
            nomeCompleto={data[0]?.nomeCompleto}
            cpf={data[0]?.cpf}
            numeroCartao={data[0]?.cartao}
            valorTotal={Number(valorTotal)}
            data={dataPurchase}
            descontoTotal={Number(descontoTotal)}
          />
          <ConferencePaymentOptions onSubmit={handleSubmit} />

          <ContainerFlex row marginBottom={20}>
            <St.DescriptionInfo>
              Comunique o cliente que deverá pagar o quanto antes, pois a
              antecipação tem prazo de validade para o mesmo dia e depois é
              cancelada!
            </St.DescriptionInfo>
          </ContainerFlex>
          <St.BoxCard>
            <ListConference data={data} />
          </St.BoxCard>
        </>
      ) : (
        <></>
      )}
    </Container>
  );
};

export default AntecipationMethodPayment;
